import type { ErrorComponentProps } from "@tanstack/react-router";
import { Provider } from "react-redux";

import GenericErrorPage from "@/GenericErrorPage";
import store from "@/redux/store";

import StaleContentFallback from "./StaleContentFallback";

const CHUNK_LOAD_ERROR =
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Loading chunk [\w-]+ failed/i;

export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);
  return CHUNK_LOAD_ERROR.test(message);
}

export default function ErrorBoundary({ error }: ErrorComponentProps) {
  if (isChunkLoadError(error)) {
    return <StaleContentFallback error={error} />;
  }

  return (
    <Provider store={store}>
      <GenericErrorPage error={error} />
    </Provider>
  );
}
